//
//
//
//
//
//
//
//

import _ from 'underscore'
import DIC from '@/index/dictionary'

export default {
  data: () => ({
    search: {
      type: 0,
      readType: 0
    },
    table: [],
    page: {
      pageNo: 1,
      pageSize: 20,
      total: 0
    },
    tabsOptions: [
      {value: 0, label: '订单', text: '订单'},
      {value: 1, label: '取货单', text: '取货单'},
      {value: 2, label: '有新的商品等待创建配送单', text: '有新的商品等待创建配送单'},
      {value: 3, label: '有未取完的商品需要重新创建配送单', text: '有未取完的商品需要重新创建配送单'}
    ],
    busEvent: undefined,
    loading: false
  }),
  watch: {
    search: {
      handler (val) {
        console.log('watch.search.handler', val)
        if (val !== undefined) {
          this.handleLoadTableData()
        }
      },
      deep:true
    },
  },
  components: {
    PageMain: () => import('./components/PageMain/index.vue')
  },
  mounted () {
    this.busEvent = this.$bus.$on('msgListReLoad', this.handleLoadData)
    this.handleLoadData()
  },
  beforeDestroy () {
    this.$bus.$off('msgListReLoad', this.handleLoadData)
  },
  methods: {
    handleLoadData () {
      this.handleLoadUnReadCount()
      this.handleLoadTableData()
    },
    handleLoadUnReadCount() {
      this.$axios.get('/mtea/store/admin/msg/unReadCount', { params: {} }).then(res => {
        _.each(this.tabsOptions, (t, i, l) => {
          let f = _.findWhere(res, {type: i})
          if (f) {
            this.tabsOptions[i].label = `${this.tabsOptions[i].text} (${f.count})`
          }else{
            this.tabsOptions[i].label = this.tabsOptions[i].text
          }
        })
        _.each(res, (t, i, l) => {

        })
      }).finally(() => {

      })
    },
    handleLoadTableData () {
      this.loading = true
      let data = _.extend({},this.search, _.pick(this.page, 'pageNo', 'pageSize'))
      // console.log('data', data)
      this.$axios.get('/mtea/store/admin/msg/list', { params: data }).then(res => {
        // console.log('res', res)
        this.page.total = res.total
        _.each(res.records, (t, i, l) => {
          if (t.messageExtras) {
            t.messageExtras = JSON.parse(t.messageExtras)
          }
        })
        this.table = res.records
      }).finally(() => {
        this.loading = false
      })
    }
  }
}
